import { render } from "./UserExperts.vue?vue&type=template&id=424faa00&scoped=true"
import script from "./UserExperts.vue?vue&type=script&lang=js"
export * from "./UserExperts.vue?vue&type=script&lang=js"

import "./UserExperts.vue?vue&type=style&index=0&id=424faa00&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424faa00"]])

export default __exports__